import type * as React from "react";
import { type ImgHTMLAttributes } from "react";
import { type ImgData } from "../../utils/models";

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
type ImgTagProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt" | "title">;

interface Props extends ImgTagProps {
  data?: ImgData;
}

const NullableImage: React.FC<Props> = ({ data, ...props }) => {
  if (!data) {
    return null;
  }
  return <img {...props} src={data.url} alt={data.altText} title={data.altText} />;
};

export default NullableImage;
